import { HttpClient } from '@opallabs/api'
import loadMe from '../loadMe'

const fetchMe = () => HttpClient().get('/api/v1/user/me')

const getMe = () => (dispatch) =>
  fetchMe()
    .then((response) => dispatch(loadMe(response.data)))
    .catch((err) => {
      console.log(err)
      throw err
    })

export default getMe
